import { EVENT_BUS_CONTEXT, EVENT_BUS_TARGET } from "./config";
import { eventBus } from "@codestreet/event-bus";

export function generateEventBusName(command: string): string {
  return eventBus.nameGenerate(EVENT_BUS_CONTEXT, EVENT_BUS_TARGET, command);
}
